import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { EmploiDuTemps } from '@teetsh/app/src/types/edt';
import { EDT_KEY } from '@teetsh/app/src/queries/edt/useEDTs';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';

export default function useDuplicateEDT() {
  const { notifyError } = useNotification();
  const { schoolyear, school } = useSchoolSchoolyear();
  const { t } = useTranslation(['emploiDuTemps']);
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation({
    mutationFn: ({
      edt,
      schoolyearId,
      schoolId,
    }: {
      edt: EmploiDuTemps;
      schoolyearId?: string;
      schoolId?: string;
    }) =>
      request(
        `/schoolyears/${schoolyearId || schoolyear.id}/schools/${
          schoolId || school.id
        }/emplois-du-temps/${edt.id}/duplicate`,
        {
          method: 'POST',
        },
      ),

    onSuccess: (_, { schoolyearId, schoolId }) => {
      queryClient.invalidateQueries({
        queryKey: [
          schoolyearId || schoolyear.id,
          schoolId || school.id,
          EDT_KEY,
          'list',
        ],
      });
    },
    onError: () => {
      notifyError({
        title: t('emploiDuTemps:messages.edt.createError'),
      });
    },
  });
  return mutateAsync;
}
